<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 mb-6>
        <v-list v-if="allParticipants">
          <template v-for="participant in allParticipants.nodes">
            <v-list-tile :key="participant.id" avatar @click="goToParticipant(participant.id)">
              <v-list-tile-content>
                <v-list-tile-title v-html="participant.fullName"></v-list-tile-title>
              </v-list-tile-content>
              <v-spacer></v-spacer>
              <v-list-tile-content>
                <v-list-tile-title> (Rank)</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-content>
                <v-list-tile-title>(Operating line)</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-content>
                <v-list-tile-title>(Years active)</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>



<script>
import { allParticipantsQuery } from "@/graphql/participantQueries.gql";
//import { allTemplateTitles, ... , ... } from '@/graphql/templateQueries.gql'

export default {
  apollo: {
    allParticipants: allParticipantsQuery,
  },
  data() {
    return {
      allParticipants: null
    };
  },
  methods: {
    goToParticipant(participantId) {
      this.$router.push({ name: "participantDetail", params: {participantId: participantId} }); //params: ...
    }
  }
};
</script>